export type CartVariantKeyInput = {
  productId: string | number;
  colorCode?: number | string | null;
  sizeCode?: number | string | null;
  pointureCode?: number | string | null;
};

/**
 * Builds a stable key so the same product can exist in the cart
 * multiple times with different variations (color/size/pointure).
 */
export function makeCartVariantKey({
  productId,
  colorCode,
  sizeCode,
  pointureCode,
}: CartVariantKeyInput) {
  const c = Number(colorCode ?? 0);
  const s = Number(sizeCode ?? 0);
  const p = Number(pointureCode ?? 0);
  return `${String(productId)}__c${c}__s${s}__p${p}`;
}

